import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mainpage',
  templateUrl: './mainpage.component.html',
  styleUrls: ['./mainpage.component.scss']
})
export class MainpageComponent implements OnInit {

  showLoader = true;

  constructor() { }

  ngOnInit(): void {
    const hideLoaderOnTranslationToggle = localStorage.getItem('hideLoaderOnTranslationToggle');

  if (hideLoaderOnTranslationToggle === 'true') {
    // Translation is toggled, hide the loader
    this.showLoader = false;

    // Reset the flag after hiding the loader
    localStorage.setItem('hideLoaderOnTranslationToggle', 'false');
  }

  }

  onToggleTextDirection() {
    this.showLoader = false;
  }

}
